import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "flex gap-3" };
const _hoisted_2 = { class: "my-auto" };
const _hoisted_3 = {
    key: 0,
    class: "px-2 py-1 text-xs font-medium text-en-blue-300"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", {
        class: "w-full",
        key: $setup.buttonKey
    }, [
        _createVNode($setup["EnTooltip"], {
            position: "bottom",
            disabled: $setup.props.state === $setup.ShortcutFilterButtonState.Disabled || $setup.isNullOrEmpty($setup.props.tooltip),
            text: $props.tooltip
        }, {
            default: _withCtx(() => [
                _createVNode($setup["EnItem"], {
                    variant: "accent",
                    state: $setup.itemState,
                    id: $setup.buttonId,
                    onClick: $setup.onFilterShortcutButtonClick
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_1, [
                            _createElementVNode("span", _hoisted_2, _toDisplayString($setup.props.label), 1 /* TEXT */),
                            ($setup.itemState === $setup.ShortcutFilterButtonState.Active && $setup.count)
                                ? (_openBlock(), _createBlock($setup["EnBadge"], {
                                    key: 0,
                                    state: "error",
                                    class: "border-0"
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString($setup.count), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                }))
                                : (false && $setup.itemState === $setup.ShortcutFilterButtonState.Active && !$setup.count)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createCommentVNode(" Temporally disabled "),
                                        _createVNode($setup["EnSkeleton"], { class: "my-auto" })
                                    ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                                    : _createCommentVNode("v-if", true)
                        ])
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["state", "id"])
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["disabled", "text"]),
        ($setup.props.hint && $setup.props.state === $setup.ShortcutFilterButtonState.Active)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString($setup.props.hint), 1 /* TEXT */))
            : _createCommentVNode("v-if", true)
    ]));
}
